<template>
	<div>
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="integral">
			<div class="integralbanner">
				<div class="swiper-container banner-list">
					<div class="clearfloat swiper-wrapper">
						<template v-for="(item, index) in banner_list">
							<div class="img-item swiper-slide">
								<router-link :to="item.page_url"><img class="img-default img" :src="item.pic_url" /></router-link>
							</div>
						</template>
					</div>
				</div>
				<div class="integralbanright">
					<template v-if="login">
						<div class="integratitle" @click="toSignin()">
							<div class="integratitleimg">
								<img class="img-default" src="../../assets/images/ttshop_userimg.jpg" alt="">
							</div>
							<h5>登录</h5>
						</div>
						<div class="zintegral">
							<h5>0</h5>
							<p>积分</p>
						</div>
					</template>
					<template v-else>
						<div class="integratitle">
							<div class="integratitleimg">
								<img class="img-default" :src="integral_user.avatar_url" alt="">
							</div>
							<h5>HI,<span v-text="user.nickname"></span></h5>
						</div>
						<div class="zintegral">
							<h5 v-text="integral_user.integral"></h5>
							<p>积分</p>
						</div>
					</template>
					<div class="integraltext clearfloat">
						<span @click="toOrderList()">我的兑换</span>
						<span @click="toIntegralDetail()">积分明细</span>
					</div>
				</div>
			</div>

			<div class="integralnav">
				<div class="w">
					<div class="integralnavcon">
						<ul class="clearfloat">
							<li @click="catIdChange(-1)" :class="{'active':cat_id == -1}">全部</li>
							<template v-for="(item,index) in cat_list">
								<li @click="catIdChange(item.id)" :class="{'active':cat_id == item.id}" v-text="item.name"></li>
							</template>
						</ul>
					</div>
				</div>
			</div>

			<div class="integralast">
				<div class="w">
					<div class="integracon">
						<div class="integraconnav">
							<ul class="clearfloat">
								<li :class="{active : 0 == sort_index}" @click="sortChange(0)"><span>综合</span></li>
								<li :class="{active : 1 == sort_index}" @click="sortChange(1)">
									<span>兑换量</span>
									<i><img class="img-default" src="../../assets/images/inonxl.png" alt /></i>
								</li>
								<li :class="{active : 2 == sort_index}" @click="sortChange(2)">
									<span>价格</span>
									<i>
										<img class="img-default" src="../../assets/images/filtrate_pic.svg" alt v-if="sort_index != 2" />
										<div v-else>
											<img src="../../assets/images/filtrate_picnext.png" alt v-if="sort_type == 0" />
											<img src="../../assets/images/filtrate_picperv.png" alt v-if="sort_type == 1" />
										</div>
									</i>
								</li>
							</ul>
						</div>

						<div class="integraconter">
							<!-- 商品列表 -->
							<div class="integracontered" v-if="goods_list && goods_list.length">
								<div class="integralist">
									<ul class="clearfloat">
										<li v-for="(item,index) in goods_list" :key="index" @click="goDetail(item.id)">
											<div class="interalimg">
												<img class="img-default" :src="item.cover_pic" alt="" :onerror="errorImg">
											</div>
											<div class="img-list d-flex" :class="['img-list','img-list'+index]" :style="{padding: item.goods_pic_list.length<=6 ? '0 0': '0 19px'}">
												<div class="swiper-container img-listcon swiper-no-swiping">
													<div class="clearfloat swiper-wrapper">
														<template v-for="(items, indexs) in item.goods_pic_list">
															<div class="img-item swiper-slide" @mouseenter="enter(items,index)">
																<img class="img-default img" :src="items" />
															</div>
														</template>
													</div>
												</div>
												<!-- 左右箭头 -->
												<div class="swiper-button-prev ttshop_prev" @click.stop v-if="item.goods_pic_list.length>6"></div>
												<div class="swiper-button-next ttshop_next" @click.stop v-if="item.goods_pic_list.length>6"></div>
											</div>
											<div class="interaltext">
												<h6>
													<span>{{item.integral}}<strong> 积分 </strong></span>
													<template v-if="item.price > 0">
														<b>+</b>
														<span>￥{{item.price}}</span>
													</template>
												</h6>
												<h5 v-text="item.name"></h5>
												<p><span v-text="item.sales"></span>人兑换</p>
											</div>

										</li>
									</ul>
								</div>
								<!-- 分页 -->
								<div class="ttshop_myorderpage clearfloat">
									<el-pagination background class="ttshop_pages" @current-change='pageChange' :current-page.sync="pages"
									 :page-size="limit" :hide-on-single-page='hide_page' layout="prev, pager, next" :total="row_count"></el-pagination>
								</div>
							</div>
							<!-- 暂无商品时暂时 -->
							<template v-else>
								<div class="zanwugoods" v-if="data_type">
									<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
									<p>暂无商品</p>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				errorImg: 'this.src="' + require('../../assets/images/lodingsb.svg') + '"', //图片加载失败
				backgroundimg: {
					backgroundImage: "url(" + require("../../assets/images/baners.jpg") + ")",
				},
				data_type: false,
				banner_list: [],
				integral_user: {},
				goods_list: [],
				cat_list: [],
				cat_id: -1,
				pages: 1,
				row_count: 0,
				limit: 20,
				hide_page: false, //只有一页隐藏分页
				sort_index: 0,
				sort_type: 0,
				user: {},
				login: true
			};
		},
		created() {
			this.getData();
			this.common.loginType(this);
		},
		methods: {
			// 数据
			getData() {
				console.log(this.user)
				this.$loading();
				this.data_type = false;
				let params = {
					page: this.pages,
					limit: this.limit
				}
				if (this.cat_id == -1) {
					params.type = 1;
				} else {
					params.cat_id = this.cat_id;
				}
				if (this.sort_index == 2) {
					if (this.sort_type == 0) {
						params.status = 2;
					} else {
						params.status = 3;
					}
				} else {
					params.status = this.sort_index;
				}
				this.$api.integral(params).then((res) => {
					if (res.code == 0) {
						this.$loading().close();
						this.goods_list = res.data.goods_list;
						this.cat_list = res.data.cat_list;
						if (res.data.banner_list && res.data.banner_list.length) {
							this.banner_list = res.data.banner_list;
						} else {
							this.banner_list = [{
								page_url: "",
								pic_url: require("../../assets/images/baners.jpg")
							}]
						}
						this.row_count = Number(res.data.row_count);
						this.integral_user = res.data.user;
						this.data_type = true;
						this.goodsSwiper();
					}
				}).catch((err) => {
					this.common.message(this, err);
				});
			},
			toOrderList() {
				if (this.login) {
					this.toSignin();
				} else {
					this.$router.push({
						path: "/integral_order_list"
					});
				}
			},
			toIntegralDetail() {
				if (this.login) {
					this.toSignin();
				} else {
					this.$router.push({
						path: "/integral_detail"
					});
				}
			},
			toSignin() {
				this.$router.push({
					name: "signin",
					query: {
						redirect: this.$router.currentRoute.fullPath,
					},
				});
			},
			// 分类筛选
			catIdChange(cat_id) {
				if (this.cat_id != cat_id) {
					this.cat_id = cat_id;
					this.getData();
				}
			},
			// 排序
			sortChange(index) {
				if (this.sort_index == index) {
					if (index == 2) {
						this.sort_type == 0 ? (this.sort_type = 1) : (this.sort_type = 0);
					} else {
						return false;
					}
				}
				this.sort_index = index;
				this.pages = 1;
				this.getData()
			},
			// 商品小图片移入事件
			enter(src, index) {
				if (src) {
					this.goods_list[index].cover_pic = src;
				}
			},
			// 详情
			goDetail(id) {
				if (this.login) {
					this.toSignin();
				} else {
					let url = this.$router.resolve({
						path: "/integral_details",
						query: {
							id: id
						}
					})
					window.open(url.href);
				}
			},
			//分页输入
			pageChange(page) {
				this.pages = page;
				this.common.backTop();
				this.getData();
			},
			// 商品小图轮播
			goodsSwiper() {
				setTimeout(() => {
					for (let i = 0; i < this.goods_list.length; i++) {
						let element = ".img-list" + i + " .img-listcon";
						let nextEl = ".img-list" + i + " .ttshop_next";
						let prevEl = ".img-list" + i + " .ttshop_prev";
						let mySwiper = new Swiper(element, {
							loop: false, // 循环模式选项
							slidesPerView: 5,
							spaceBetween: 4,
							observer: true,
							observeParents: true,
							navigation: {
								nextEl: nextEl,
								prevEl: prevEl,
							}
						});
					}
					new Swiper(".banner-list", {
						autoplay: {
							delay: 2500,
							disableOnInteraction: false,
						},
						loop: true, // 循环模式选项
						observer: true,
						observeParents: true,
						fadeEffect: {
							crossFade: true
						}
					});
				}, 0)
			}
		},
	};
</script>

<style lang="scss" scoped>
	.integral {
		width: 100%;
		height: 100%;

		.integralbanner {
			width: 100%;
			height: 350px;
			position: relative;

			.banner-list {
				width: 100%;
				height: 100%;
			}

			.integralbanright {
				position: absolute;
				z-index: 99;
				top: 53px;
				right: calc((100vw - 1190px)/2);
				width: 190px;
				height: 244px;
				background: #fff;
				padding: 32px 12px;
				box-sizing: border-box;

				.integratitle {
					width: 100%;
					margin-bottom: 20px;

					.integratitleimg {
						width: 36px;
						height: 36px;
						border-radius: 50%;
						margin: 0 auto 12px;

						img {
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
							border-radius: 50%;
						}
					}

					h5 {
						font-size: 12px;
						color: #333;
						font-weight: 400;
						line-height: 12px;
						text-align: center;
					}
				}

				.zintegral {
					width: 100%;
					margin-bottom: 20px;

					h5 {
						font-size: 32px;
						color: #FF4300;
						font-weight: 400;
						line-height: 32px;
						text-align: center;
						margin-bottom: 10px;
					}

					p {
						font-size: 12px;
						color: #333;
						text-align: center;
						font-weight: 400;
						line-height: 12px;
					}
				}

				.integraltext {
					width: 100%;

					span {
						float: left;
						width: 77px;
						height: 26px;
						border-radius: 13px;
						text-align: center;
						line-height: 26px;
						font-size: 12px;
						color: #fff;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						background: #FF0E25;
						margin-right: 12px;
						cursor: pointer;

						&:last-child {
							background: #FF9010;
							margin-right: 0;
						}

						&:first-child:hover {
							box-shadow: 0 5px 10px rgba(255, 14, 37, 0.2);
						}

						&:last-child:hover {
							box-shadow: 0 5px 10px rgba(255, 144, 16, 0.2);
						}
					}
				}
			}
		}

		.integralnav {
			width: 100%;
			background: #FAFAFA;
			padding: 14px 0 2px 0;
			box-sizing: border-box;

			.integralnavcon {
				width: 100%;

				ul {
					li {
						float: left;
						font-size: 12px;
						color: #333;
						position: relative;
						font-weight: 400;
						line-height: 12px;
						margin: 0 16px;
						cursor: pointer;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						margin-bottom: 12px;

						&::before {
							content: '';
							width: 1px;
							height: 12px;
							background: #D8D8D8;
							position: absolute;
							top: 0;
							right: -16px;
						}

						&:first-child {
							margin-left: 0;
						}

						&:last-child::before {
							display: none;
						}

						&:hover,
						&.active {
							color: #FF0E25;
						}
					}
				}
			}
		}

		.integralast {
			width: 100%;
			background: #fff;
			padding: 20px 0 60px 0;
			box-sizing: border-box;

			.integracon {
				width: 100%;

				.integraconnav {
					width: 100%;
					margin-bottom: 20px;

					ul {
						li {
							float: left;
							cursor: pointer;
							margin-right: 28px;

							span {
								font-size: 12px;
								color: #666;
								font-weight: 400;
								line-height: 12px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
							}

							i {
								display: inline-block;
								width: 12px;
								height: 12px;
								vertical-align: -2px;
							}

							&:last-child {
								margin-right: 0;
							}

							&:hover span {
								color: #FF0E25;
							}

							&.active span {
								color: #FF0E25;
							}
						}
					}
				}

				.integraconter {
					width: 100%;

					.integracontered {
						width: 100%;

						.integralist {
							width: 100%;

							ul {
								li {
									cursor: pointer;
									float: left;
									width: 234px;
									height: 384px;
									background: #fff;
									transition: .5s;
									-moz-transition: .5s;
									-webkit-transition: .5s;
									-o-transition: .5s;
									padding: 8px 12px 14px 12px;
									box-sizing: border-box;
									margin-bottom: 28px;
									margin-right: 5px;

									.interalimg {
										width: 214px;
										height: 214px;
										overflow: hidden;
										position: relative;
										margin-bottom: 8px;

										img {
											display: block;
											width: 100%;
											height: 100%;
											object-fit: cover;
										}

										.interalimgtext {
											width: 100%;
											height: 28px;
											font-size: 12px;
											color: #fff;
											text-align: center;
											line-height: 28px;
											padding: 0 10px;
											box-sizing: border-box;
											background: #FF0E25;
											position: absolute;
											left: 0;
											bottom: -30px;
											opacity: 0;
											transition: .5s;
											-moz-transition: .5s;
											-webkit-transition: .5s;
											-o-transition: .5s;
											cursor: pointer;
										}
									}

									.img-list {
										width: 100%;
										padding: 0 18px;
										box-sizing: border-box;
										margin-top: 8px;
										position: relative;
										margin-bottom: 12px;

										.img-listcon {
											width: 100%;
											padding: 0 1px;
											box-sizing: border-box;

											.img-item {
												width: 31px !important;
												height: 31px;
												padding: 2px;
												border: 1px solid #ebebeb;
												box-sizing: border-box;
												margin-right: 4px;
												transition: .5s;
												-moz-transition: .5s;
												-webkit-transition: .5s;
												-o-transition: .5s;
												cursor: pointer;

												.img {
													width: 100%;
													height: 100%;
												}

												&:hover {
													border-color: #FF0E25;
												}

												&:last-child {
													margin-right: 0 !important;
												}
											}
										}

										.ttshop_prev {
											width: 14px;
											height: 14px;
											margin-top: -7px;
											background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
											left: 0;
											cursor: pointer;
											z-index: 100;
											outline: none;
										}

										.ttshop_next {
											width: 14px;
											height: 14px;
											margin-top: -7px;
											background: url(../../assets/images/ttshop_scright.png) center no-repeat;
											right: 0;
											cursor: pointer;
											z-index: 100;
											outline: none;
										}
									}

									.interaltext {
										width: 100%;

										h6 {
											margin-bottom: 8px;
											font-weight: 500;

											span {
												font-size: 20px;
												color: #FF4300;

												strong {
													font-size: 12px;
													color: #999;
													font-weight: 400;
													vertical-align: 1px;
												}
											}

											b {
												font-size: 14px;
												color: #D8D8D8;
												font-weight: 400;
												vertical-align: 2px;
											}
										}

										h5 {
											display: block;
											font-size: 12px;
											color: #666;
											font-weight: 400;
											line-height: 18px;
											height: 36px;
											display: -webkit-box;
											-webkit-box-orient: vertical;
											-webkit-line-clamp: 2;
											overflow: hidden;
											margin-bottom: 10px;
											transition: .5s;
											-moz-transition: .5s;
											-webkit-transition: .5s;
											-o-transition: .5s;
										}

										p {
											font-size: 12px;
											color: #999;
											font-weight: 400;
											line-height: 12px;

											span {
												font-size: 12px;
												line-height: 12px;
												color: #0E9CFF;
												margin-right: 6px;
											}
										}
									}

									&:nth-child(5n) {
										margin-right: 0;
									}

									&:hover {
										box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
									}

									&:hover .interalimg .interalimgtext {
										bottom: 0;
										opacity: 1;
									}

									&:hover .interaltext h5 {
										color: #FF0E25;
									}
								}
							}
						}

						.ttshop_myorderpage {
							width: 100%;
							margin-top: 20px;

							.ttshop_pages {
								display: table;
								margin: 0 auto;
							}
						}
					}

					// 暂无商品
					.zanwugoods {
						width: 100%;
						padding: 150px 0;
						box-sizing: border-box;
						display: none;

						img {
							display: block;
							width: 93px;
							height: 80px;
							margin: 0 auto 20px;
						}

						p {
							font-size: 16px;
							color: #333;
							text-align: center;
						}
					}
				}
			}
		}
	}
</style>
